import { createFileRoute } from '@tanstack/react-router';

import { AwardBrowse } from '@/module/Author/Award';

export const Route = createFileRoute('/_auth/author/_author/award/_award/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <AwardBrowse />;
}
